import { useReveal } from "../../hooks/useReveal";

const STEPS = [
  {
    n: "01",
    title: "Free 15-min phone call",
    body: "A no-cost conversation to see if we’re a good fit.",
  },
  {
    n: "02",
    title: "50-min or 90-min Sessions",
    body: "Weekly or bi-weekly — protected, regular time.",
  },
  {
    n: "03",
    title: "Steady momentum",
    body: "Rhythm that lets the work actually take root.",
  },
];

export const Process = () => {
  const ref = useReveal();
  return (
    <section
      id="process"
      data-testid="process-section"
      className="bg-[#F3F0EA]"
    >
      <div className="mx-auto max-w-[1320px] px-6 md:px-10 lg:px-16 py-20 md:py-20 lg:py-24">
        <div ref={ref} className="reveal">
          <div className="max-w-3xl mb-12 md:mb-16">
            <p className="eyebrow-rule text-[11px] uppercase tracking-[0.28em] text-[#4A4D4A] mb-5">
              <span>03 · How I Work</span>
            </p>
            <h2 className="font-serif-display text-3xl md:text-4xl lg:text-[3rem] leading-[1.1] tracking-[-0.02em] text-[#1A1C1A] font-medium">
              A simple, considered{" "}
              <em className="italic font-normal text-[#1B2E26]">first step</em>.
            </h2>
          </div>

          {/* Visual horizontal flow */}
          <div className="relative grid grid-cols-1 md:grid-cols-3 gap-0 border-t border-l border-[#DCD7CE] bg-[#FDFBF7]">
            {STEPS.map((step, idx) => (
              <div
                key={step.n}
                data-testid={`process-step-${step.n}`}
                className="relative p-8 md:p-10 border-r border-b border-[#DCD7CE]"
              >
                <p className="font-serif-display text-6xl md:text-7xl text-[#1B2E26] leading-none font-light">
                  {step.n}
                </p>
                <h3 className="mt-6 font-serif-display text-xl md:text-2xl text-[#1A1C1A] leading-snug">
                  {step.title}
                </h3>
                <p className="mt-3 text-[#4A4D4A] text-sm md:text-base leading-relaxed">
                  {step.body}
                </p>
                {/* connector arrow on md+ */}
                {idx < STEPS.length - 1 && (
                  <span
                    aria-hidden="true"
                    className="hidden md:block absolute top-1/2 -right-3 z-10 w-6 h-6 bg-[#F3F0EA] border border-[#DCD7CE] rotate-45 -translate-y-1/2"
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
